import Moment from 'moment'
import MenuGroupItem from "@/model/dailymenu/MenuGroupItem";
import i18n from "../../i18n";
export default class DailyMenuOffer {

  private constructor (
    readonly date: Date,
    readonly menuGroupList: MenuGroupItem[],

  ) {}

  get dayName (): string {
    return Moment(this.date).locale(i18n.locale).format("dddd")
  }

  get formatedDate (): string {
    const date = Moment(this.date);
    return date.format("D.M.Y")
  }

  static createFromResponse (responseData: any): DailyMenuOffer {
    return new DailyMenuOffer(
      Moment(responseData.date).toDate(),
      MenuGroupItem.createFromList(responseData.data)
    )
  }
}
